import cn from "classnames";
import { FormTemplate } from "components/modal/templates";
import { serializeReq } from "components/shared/form";
import Loader from "components/shared/loader";
import { getInitialStateFromConfig } from "helpers/form";
import React from "react";
import { applyPlanningComment } from "sources/books/trucks";

const config = {
    id: {},
    planningComment: {
        inputProps: { name: "planningComment" },
        textarea: true,
    },
};

const initialState = getInitialStateFromConfig(config);

class PlanningCommentForm extends FormTemplate {
    close = (newValue) => {
        const { callback, close } = this.props;
        this.setState({ isLoading: false });
        if (callback) {
            callback({ planningComment: newValue });
        }
        return close();
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { isLoading, ...state } = this.state;
        if (!isLoading) {
            if (this.isValidForm(state)) {
                this.setState({ isLoading: true, isValid: true });
                return this.sendRequest(serializeReq(state)).then((res) => {
                    if (res) {
                        this.props.mergeParams && this.props.mergeParams();
                        this.close(this.state.planningComment);
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    sendRequest = (stateData) => {
        return applyPlanningComment(stateData);
    };

    renderBodyInner = () => {
        const { config } = this.props;
        return this.renderField(config.planningComment);
    };

    deleteComment = () => {
        this.setState({ isLoading: true, isValid: true });
        return this.sendRequest(serializeReq({ id: this.props.carId, planningComment: null })).then((res) => {
            if (res) {
                this.close(null);
            } else {
                this.setState({ isLoading: false, isValid: false });
            }
        });
    };

    renderFormActions = () => {
        const cname = cn("modal-window__footer", {
            "modal-window__footer--between": this.props.planningComment,
            "modal-window__footer--right": !this.props.planningComment,
        });
        return (
            <div className={cname}>
                {this.renderActionDelete()}
                {this.renderActionSend()}
            </div>
        );
    };

    renderActionDelete = () => {
        if (!this.props.planningComment) {
            return null;
        }

        const cname = "btn btn-outline-danger btn-sm modal-window__footer-action mx-0";
        return (
            <div className={cname} onClick={this.deleteComment}>
                Удалить
            </div>
        );
    };

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm mx-0";
        return <input type="submit" className={cname} value="Сохранить" />;
    };

    renderBody = () => {
        if (this.state.isLoading) {
            return (
                <div className="loader-wrap">
                    <Loader prefix="margin-center" />
                </div>
            );
        }
        const cname = cn("modal-window__form", { "modal-window__form--invalid": !this.state.isValid });
        return (
            <form className={cname} onSubmit={this.handleSubmit}>
                {this.renderBodyInner()}
                {this.renderFormActions()}
            </form>
        );
    };
}

const ConfiguredModal = (props) => {
    initialState.id = props.carId;
    initialState.planningComment = props.planningComment;
    return <PlanningCommentForm {...props} config={config} initialState={initialState} />;
};

export default ConfiguredModal;
